





























import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import DeferredAutocomplete from "@/components/misc/DeferredAutocomplete.vue";
import { Notification } from "@/store/modules/notifications";

export class PropertyImportModel {
  externalId = "";
}

@Component({
  components: {
    LoadingOverlay,
    DeferredAutocomplete,
  },
})
export default class PropertyImport extends Vue {
  @PropSync("isOpen") _isOpen?: boolean;

  loading = false;

  propertyImportModel = new PropertyImportModel();
  isFormValid = false;

  importProperty() {
    this.loading = true;
    Vue.axios
      .post("properties/importProperty", this.propertyImportModel)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Property.Import.Started"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
    };
  }

  @Watch("_isOpen")
  isOpenWatch() {
    this.propertyImportModel = new PropertyImportModel();
  }
}
